import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  readonly contactEmail = 'sandra.saldana@chevron.com';
  readonly mailtoLink = `mailto:${this.contactEmail}`;
  readonly currentYear = new Date().getFullYear();
  readonly buildDate = this.getBuildDate();

  private getBuildDate(): string {
    const lastModified = document.lastModified;
    const parsedDate = new Date(lastModified);

    if (!Number.isNaN(parsedDate.getTime())) {
      return parsedDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }

    const now = new Date();
    return now.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}
